import { render, staticRenderFns } from "./DetailPanel.vue?vue&type=template&id=5c22bbb6&scoped=true&"
import script from "./DetailPanel.vue?vue&type=script&lang=js&"
export * from "./DetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailPanel.vue?vue&type=style&index=0&id=5c22bbb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c22bbb6",
  null
  
)

export default component.exports